import moment from "moment";
import dayjs from "dayjs";
import { useState } from "react";
import { Check, ChevronDown, Funnel, FunnelX } from "lucide-react";
import { Button, DatePicker, Form, Popover } from "antd";

const { RangePicker } = DatePicker;

export default function HomeHeader({
  title,
  subtitle,
  clearFilters,
  setFilters,
  filters,
  branches,
  actions = <></>,
}: any) {
  const [showRange, setShowRange] = useState(true);
  const [isFiltered, setFiltered] = useState<boolean>(false);

  const [form] = Form.useForm();

  const onDateChange = (date: any) => {
    if (date === null) return;
    setFiltered(true);
    setFilters({
      ...filters,
      startDate: moment(new Date(date)),
      endDate: moment(new Date(date)),
    });
    setDates({
      startDate: moment(new Date(date)),
      endDate: moment(new Date(date)),
      isRange: false,
    });
  };

  const onRangeChange = (date: any) => {
    if (date === null) return;
    setFiltered(true);
    setFilters({
      ...filters,
      startDate: moment(new Date(date[0])),
      endDate: moment(new Date(date[1])),
    });
  };

  const initial = {
    dates: {
      startDate: moment().startOf("month"),
      endDate: moment().endOf("month"),
      isRange: true,
    },
    option: {
      id: 3,
      name: "This Month",
      start: moment().startOf("month"),
      end: moment().endOf("month"),
      isRange: true,
    },
    branch: {
      _id: 0,
      name: "All Branches",
    },
  };

  const [dates, setDates] = useState<any>({
    startDate: moment().startOf("month"),
    endDate: moment().endOf("month"),
    isRange: true,
  });

  const [option, setOption] = useState<any>({ ...initial?.option });
  const options = [
    {
      id: 1,
      name: "Today",
      start: moment(new Date()),
      end: moment(new Date()),
      isFiltered: true,
      showRange: false,
    },
    {
      id: 2,
      name: "This Week",
      start: moment().startOf("week"),
      end: moment().endOf("week"),
      isFiltered: true,
      showRange: true,
    },
    {
      id: 3,
      name: "This Month",
      start: moment(new Date()).startOf("month"),
      end: moment(new Date()).endOf("month"),
      isFiltered: false,
      showRange: true,
    },
    {
      id: 4,
      name: "Year to Date",
      start: moment(new Date()).startOf("year"),
      end: moment(new Date()),
      isFiltered: true,
      showRange: true,
    },
  ];

  const rangeContent = (
    <div>
      {options?.map((item: any, index: number) => (
        <div
          className="flex flex-col justify-start items-start w-full text-3xs"
          key={index}
        >
          <button
            onClick={() => {
              setOption(item);
              setFiltered(item?.isFiltered);
              setShowRange(item?.showRange);
              setFilters({
                ...filters,
                startDate: moment(new Date(item.start)),
                endDate: moment(new Date(item.end)),
              });
              setDates({
                startDate: moment(new Date(item.start)),
                endDate: moment(new Date(item.end)),
                isRange: false,
              });
            }}
            className="py-1 border-t focus:outline-none w-full flex items-start"
          >
            <div
              className={`${
                option?.id === item?.id ? "bg-green-600" : ""
              } w-6 h-6 border mr-2 flex items-center justify-center`}
            >
              <Check color="#FFFFFF" />
            </div>
            {item?.name}
          </button>
        </div>
      ))}

      <div className="flex flex-col justify-start items-start w-full border-t-2 text-3xs">
        <button
          onClick={() => {
            setShowRange(true);
            setOption({
              id: 5,
              name: "Date Range",
              start: moment(new Date()),
              end: moment(new Date()),
            });

            setDates({
              startDate: moment(new Date()),
              endDate: moment(new Date()),
              isRange: true,
            });
          }}
          className="py-1 border-t focus:outline-none w-full flex items-start"
        >
          Date Range
        </button>
      </div>
    </div>
  );
  const [branch, setBranch] = useState<any>({ ...initial?.branch });
  const branchContent = (
    <div>
      {branches?.map((item: any, index: number) => (
        <div
          className="flex flex-col justify-start items-start w-full text-3xs"
          key={index}
        >
          <button
            onClick={() => {
              setBranch(item);
              setFilters({ ...filters, branch: item?._id });
            }}
            className="py-1 border-t focus:outline-none w-full flex items-start"
          >
            <div
              className={`${
                branch?._id === item?._id ? "bg-green-600" : ""
              } w-6 h-6 border mr-2 flex items-center justify-center`}
            >
              <Check color="#FFFFFF" />
            </div>
            {item?.name}
          </button>
        </div>
      ))}

      <div className="flex flex-col justify-start items-start w-full border-t-2 text-3xs">
        <button
          onClick={() => {
            setBranch({
              ...initial?.branch,
            });
            setFilters({ ...filters, branch: 0 });
          }}
          className="py-1 border-t focus:outline-none w-full flex items-start"
        >
          All Branches
        </button>
      </div>
    </div>
  );

  const handleClearFilters = () => {
    setOption({ ...initial.option });
    setBranch({ ...initial.branch });
    setDates({
      startDate: moment().startOf("month"),
      endDate: moment().endOf("month"),
      isRange: true,
    });
    setFiltered(false);
    setShowRange(true);
    setFilters({
      branch: { ...initial?.branch },
      startDate: moment().startOf("month"),
      endDate: moment().startOf("month"),
    });
    clearFilters();
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center border px-2 bg-white mb-1">
      <div className="">
        <div className="font-bold capitalize text-lg">{title}</div>
        <div className="text-gray-600 mb-1">{subtitle}</div>
      </div>
      <div className="flex text-3xs">
        <Form layout="inline" form={form}>
          {showRange ? (
            <div className="flex justify-center items-center text-3xs">
              <Form.Item name="ranger">
                <RangePicker
                  allowClear={true}
                  onChange={onRangeChange}
                  format={"DD/MM/YYYY"}
                  defaultValue={[dayjs(dates.startDate), dayjs(dates.endDate)]}
                />
              </Form.Item>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <Form.Item name="picker">
                <DatePicker
                  onChange={onDateChange}
                  defaultValue={dayjs(dates.startDate)}
                  format={"DD/MM/YYYY"}
                  placeholder="Specific date"
                  className=" border-gray-300 rounded-none"
                />
              </Form.Item>
            </div>
          )}
          <Popover content={rangeContent} title="Options" placement="bottom">
            <button className="flex items-center cursor-pointer focus:outline-none text-3xs border px-2 mx-2">
              <div className="">{option?.name}</div>
              <div className="ml-1">
                <ChevronDown />
              </div>
            </button>
          </Popover>

          <Popover content={branchContent} title="Branches" placement="bottom">
            <button className="flex items-center cursor-pointer focus:outline-none text-3xs border px-2">
              <div className="">{branch?.name}</div>
              <div className="ml-1">
                <ChevronDown />
              </div>
            </button>
          </Popover>
          <Button
            className="ml-2 focus:outline-none hover:bg-red-100 rounded-none"
            onClick={() => {
              handleClearFilters();
            }}
          >
            {isFiltered ? (
              <FunnelX size={14} color={isFiltered ? "red" : "gray"} />
            ) : (
              <Funnel size={14} color={isFiltered ? "red" : "gray"} />
            )}
          </Button>
        </Form>
        <div className="">{actions}</div>
      </div>
    </div>
  );
}
